/**
 * Query params a directory appends to a provider's PSL URL to open quick checkout on a slot the
 * visitor already picked. Both ends import these: a directory builds the link, the PSL's
 * `landing-page.component.ts` parses it.
 */
export enum QuickCheckoutParam {
  REQUEST_SESSION = 'requestSession',
  START_TIME = 'startTime',
  END_TIME = 'endTime',
  SESSION_TYPE = 'sessionType'
}

/** The value `REQUEST_SESSION` must carry for the PSL to treat the visit as a booking. */
export const QUICK_CHECKOUT_REQUESTED = 'true';
